/* eslint-disable */
import Article from '@/pages/adminCenter/page/article/index';
import EnterpriseAdd from '@/pages/adminCenter/page/article/enterprise/add';
import TenderingAdd from '@/pages/adminCenter/page/article/tendering/add';
import TenderingEdit from '@/pages/adminCenter/page/article/tendering/edit';
import EnterpriseEdit from '@/pages/adminCenter/page/article/enterprise/edit';
const ArticleRouter = [{
    path: '/',
    redirect: {
      path: 'article'
    }
  }, {
    path: 'article',
    name: 'article',
    component: Article,
  },
  {
    path: 'article/enterprise/add',
    name: '企业动态-新增',
    component: EnterpriseAdd
  },
  {
    path: 'article/enterprise/edit/:newsId',
    name: '企业动态-编辑',
    component: EnterpriseEdit
  },
  {
    path: 'article/tendering/add',
    name: '企业动态-新增',
    component: TenderingAdd
  },
  {
    path: 'article/tendering/edit/:bidsId',
    name: '招聘管理-编辑',
    component: TenderingEdit
  }
]
export default [...ArticleRouter]



// WEBPACK FOOTER //
// ./src/router/admin/article.js